
document.addEventListener("DOMContentLoaded", function() {
  console.log("FAQ tab script loaded");

  // Szukamy istniejącego FAQ po ID
  const faqSection = document.querySelector('#faq');

  if (faqSection) {
    console.log("FAQ section exists");

    // Odroczone dodanie zakładki, żeby zakładki zdążyły się wyrenderować
    setTimeout(() => {
      const tabContainer = document.querySelector('#opis-navigation');
      if (tabContainer && !document.querySelector('.faq-tab-opis')) {
        const newTab = document.createElement('div');
        newTab.classList.add('tab-opis');
        newTab.innerHTML = `
          <a class="inactive-tab-opis faq-tab-opis" href="#faq">FAQ</a>
          <div class="inactive-tab-indicator-opis"></div>
        `;
        tabContainer.appendChild(newTab);
        console.log("FAQ tab added!");
      } else {
        console.log("Tab container not found or FAQ tab already exists");
      }
    }, 100); // odroczenie 100ms, żeby DOM był gotowy
  } else {
    console.log("No FAQ section found");
  }
});

